import { SuccessCallback } from '@dxb-web-ui-framework/common/domain/RestfulDataTransfer/DataService/types';
import { DeviceData, RegisterDeviceRequestDTO, RegisterDeviceResponseDTO } from '../entities';
import { DeleteDeviceResponseBody } from '../entities/DeleteDeviceResponseDTO';
import { CreateDeleteDeviceAuthorizationResponseBody } from '../entities/CreateDeleteDeviceAuthorizationResponseDTO';
import { IDeviceRepository } from '../entities/IDeviceRepository';
import { IDeviceService } from '../entities/IDeviceService';

export class DeviceServiceImpl implements IDeviceService {
  itemRepo: IDeviceRepository;

  constructor(ir: IDeviceRepository) {
    this.itemRepo = ir;

    this.GetDevices = this.GetDevices.bind(this);
    this.CreateDeleteDeviceAuthorization = this.CreateDeleteDeviceAuthorization.bind(this);
    this.DeleteDevice = this.DeleteDevice.bind(this);
    this.RegisterNewDevice = this.RegisterNewDevice.bind(this);
  }

  GetDevices(params: { pageSize: number; pageOffset: number }): Promise<DeviceData> {
    return this.itemRepo.GetDevices(params.pageSize, params.pageOffset);
  }

  CreateDeleteDeviceAuthorization(params: { deviceId: number }): Promise<CreateDeleteDeviceAuthorizationResponseBody> {
    return this.itemRepo.CreateDeleteDeviceAuthorization(params.deviceId);
  }

  DeleteDevice(params: { requestId: string; successCallback: SuccessCallback }): Promise<DeleteDeviceResponseBody> {
    return this.itemRepo.DeleteDevice(params.requestId, params.successCallback);
  }

  RegisterNewDevice(params: {
    requestData: RegisterDeviceRequestDTO;
    successCallback?: SuccessCallback;
    errorCallback?: ErrorCallback;
  }): Promise<RegisterDeviceResponseDTO> {
    return this.itemRepo.RegisterNewDevice(params.requestData, params.successCallback, params.errorCallback);
  }
}
